import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const t = setInterval(async () => {
      attempts++;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          clearInterval(t);
          setStatus("paid");
          refresh();
        } else if (attempts > 20) {
          clearInterval(t);
          setStatus("timeout");
        }
      } catch { /* ignore */ }
    }, 2000);
    return () => clearInterval(t);
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-success">
      <div className="soft-card p-10 max-w-md text-center">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-14 h-14 text-[#81B29A] mx-auto" />
            <h1 className="font-display text-3xl tracking-tight mt-4">Welcome to Premium 🌱</h1>
            <p className="text-[#5b5f6e] mt-2">Unlimited reflections and challenges are unlocked.</p>
            <Link to="/app" className="mt-6 inline-flex pill-btn bg-[#E07A5F] text-white hover:bg-[#D26A4F]" data-testid="success-go-app">Back to Bloom</Link>
          </>
        ) : status === "timeout" || status === "error" ? (
          <>
            <h1 className="font-display text-2xl">Still processing…</h1>
            <p className="text-[#5b5f6e] mt-2">Your payment might just be a little slow — refresh in a moment.</p>
            <Link to="/app" className="mt-6 inline-flex pill-btn bg-[#2D3142] text-white">Back to app</Link>
          </>
        ) : (
          <>
            <div className="w-12 h-12 mx-auto mb-4 rounded-full border-2 border-[#E07A5F] border-t-transparent animate-spin" />
            <p className="text-sm uppercase tracking-[0.2em] text-[#8A8D98]">Confirming payment</p>
          </>
        )}
      </div>
    </div>
  );
}
